module.exports = __webpack_public_path__ + "static/media/step3.e7d95bfc.png";